<template>
	<div id="navigation">
		<header>
			<ul>
				<li @click="homePage"><img src="../../assets/img/homePage/headLogo.png" /></li>
				<li v-if="appLet == '1'" @click="purchase">购买学习</li>
				<li @click="aboutUs">联系我们</li>
				<li v-if="appLet == '1'" @click="xz2">下载APP</li>
			</ul>
		</header>
	</div>
</template>
<script>
import { Dialog } from 'vant';
import wx from 'weixin-js-sdk';
export default {
	data() {
		return {
			appLet: '1'
		};
	},
	created() {
		let _this = this;
		var ua = navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == 'micromessenger') {
			// ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
			wx.miniProgram.getEnv(res => {
				if (res.miniprogram) {
					_this.appLet = '2';
					// alert('在小程序里');
				} else {
					_this.appLet = '1';
					// alert('不在小程序里');
				}
			});
		} else {
			_this.appLet = '1';
		}
	},
	methods: {
		homePage() {
			this.$router.push({
				name: 'HomePage',
				query: {}
			});
		},
		aboutUs() {
			this.$router.push({
				name: 'AboutUs',
				query: {}
			});
		},
		purchase() {
			this.$router.push({
				name: 'Login',
				query: {}
			});
		},
		xz2() {
			window.location.href = 'https://upgrade.jiaodao11.com/mobile/index.html';
		}
	}
};
</script>
<style lang="scss" scope>
#navigation {
	// display: flex;
	header {
		height: 1.2rem;
		width: 92%;
		margin: 0 auto;
	}

	ul {
		display: flex;
		// justify-content: center;
		// align-items: center;
		font-size: 0.32rem;
		color: #333;
		text-align: left;
	}

	ul > li {
		//border: 0.01333rem solid black;
		-webkit-box-flex: 1;
		-ms-flex: 1;
		flex: 1;
		//flex-grow: 1;
		// flex-shrink:1;
		height: 1.2rem;
		line-height: 1.2rem;
		//background: red;
	}

	ul > li:nth-child(1) {
		flex-grow: 1.6; //扩大两倍 flex-shrink:2;//缩小两倍
		padding-left: 0.1rem;

		img {
			width: 0.6rem;
			height: 0.6rem;
			vertical-align: middle;
		}
	}
}

.van-dialog__message {
	height: 1.2rem !important;
	line-height: 1.2rem !important;
	font-size: 0.32rem !important;
}

.van-dialog__footer--buttons {
	height: 1rem !important;
}

.van-button--large {
	line-height: 1rem !important;
	font-size: 0.32rem !important;
}
</style>
